import React, { Component } from "react";
import { connect } from "react-redux";
import { getReport, getStandaloneReport } from "./actions";
import MapContainer from "../MapContainer";
import YesIcon from "@material-ui/icons/Done";
import NoIcon from "@material-ui/icons/Close";
import { gridStyle, cellStyle } from "../gridHelper";
import { StyledHeader } from "../../styles";
import { Card, CardContent, Button, Typography } from "@material-ui/core";

import Avatar from "@material-ui/core/Avatar";

import { selectCurrentReport } from "./selectors";
import ReactToPrint from "react-to-print";

import "../imgDiv.css";
class PPEInspection extends Component {
    constructor(props) {
        super(props);
        const path = props.location.pathname.split("/");
        if (path[2] === "reports") {
            props.getStandaloneReport(
                path[2].replace(/-/g, "_"),
                path[3],
                path[5].replace(/_/g, " ").replace(/\./g, ":"),
                path[4].replace(/-/g, "_")
            );
        } else {
            props.getReport(
                path[6],
                path[2].replace(/-/g, "_"),
                path[3],
                path[4].replace(/-/g, "_"),
                path[5].replace(/-/g, "_"),
                props.match.params.report_id
                    .replace(/_/g, " ")
                    .replace(/\./g, ":"),
                path[7].replace(/-/g, "_")
            );
        }
        this.state = {
            reportRetrieved: false,
            report: [],
        };
    }
    componentDidUpdate(prevState) {
        if (prevState.report !== this.props.report) {
            this.setState({ report: this.props.report });
        }
    }

    yesNoRender = (item) => {
        if (item === "Yes") {
            return (
                <span
                    style={{
                        margin: "auto auto",
                        position: "relative",
                        display: "block",
                        textAlign: "center",
                    }}
                >
                    <Avatar
                        style={{
                            height: "40px",
                            width: "40px",
                            margin: "0 auto",
                            fontWeight: "700",
                            border: "1px green solid",
                            color: "green",
                            fontSize: "30px",
                            background: "white",
                        }}
                    >
                        <b>
                            {" "}
                            <YesIcon />
                        </b>
                    </Avatar>
                </span>
            );
        } else
            return (
                <span
                    style={{
                        margin: "auto auto",
                        position: "relative",
                        display: "block",
                        textAlign: "center",
                    }}
                >
                    <Avatar
                        fontSize="large"
                        style={{
                            height: "40px",
                            width: "40px",
                            border: "1px solid red",
                            color: "red",
                            margin: 0,
                            fontWeight: "700",
                            fontSize: "30px",
                            background: "white",
                        }}
                    >
                        <b>
                            {" "}
                            <NoIcon />
                        </b>
                    </Avatar>
                </span>
            );
    };

    renderSigs(attachedPhotos) {
        let photoRow = 2;
        let photoCell = 1;
        return attachedPhotos.map((photo, i) => {
            let photoInfo = (
                <React.Fragment key={i}>
                    <div
                        style={cellStyle(
                            photoRow,
                            photoCell,
                            photoRow,
                            photoCell,
                            true
                        )}
                    >
                        {photo.signature_name}
                    </div>
                    <div
                        style={cellStyle(
                            photoRow,
                            photoCell + 1,
                            photoRow,
                            photoCell + 1,
                            true
                        )}
                    >
                        {photo.signature_timestamp}
                    </div>
                    <div
                        style={cellStyle(
                            photoRow + 1,
                            photoCell,
                            photoRow + 1,
                            photoCell + 2
                        )}
                    >
                        <img
                            src={photo.signature_url}
                            alt="Site "
                            onClick={() => {
                                this.setState({
                                    selectedPhoto: photo,
                                    imageModal: true,
                                });
                            }}
                            style={{
                                width: 300,
                                height: 300,
                                margin: "auto",
                                cursor: "pointer",
                            }}
                        />
                    </div>
                </React.Fragment>
            );
            photoCell += 2;
            if (photoCell === 9) {
                photoRow += 2;
                photoCell = 1;
            }
            return photoInfo;
        });
    }

    render() {
        const report = this.props.report === false ? [] : this.props.report;
        const cstyle = cellStyle;
        const gstyle = gridStyle;
        const color = this.props.color;
        const iconCheck = this.yesNoRender;
        const iconH = 50;
        const iconW = 50;
        return (
            <Card>
                <StyledHeader>
                    <Typography variant="h5">PPE Inspection Form</Typography>
                </StyledHeader>
                <CardContent>
                    <ReactToPrint
                        onBeforePrint={() => {
                            setTimeout(undefined, 2000);
                        }}
                        trigger={() => (
                            <Button
                                style={{
                                    fontSize: "30px",
                                    marginBottom: "10px",
                                }}
                                color="primary"
                                variant="contained"
                            >
                                Print
                            </Button>
                        )}
                        content={() => this.componentRef}
                    />
                    {report && (
                        <div ref={(el) => (this.componentRef = el)}>
                            {this.props.header && (
                                <this.props.header
                                    date={this.props.match.params.report_id}
                                    reportType={this.props.reportType}
                                />
                            )}
                            <div style={{ width: "100%", overflow: "hidden" }}>
                                <div style={{ width: "60%", float: "left" }}>
                                    <div style={gstyle(5, 13)}>
                                        <div
                                            style={cstyle(
                                                1,
                                                1,
                                                1,
                                                13,
                                                false,
                                                true
                                            )}
                                        >
                                            <b>Details</b>
                                        </div>
                                        <div style={cstyle(2, 1, 2, 7)}>
                                            <b>Name:</b>
                                        </div>
                                        <div style={cstyle(2, 7, 2, 13, true)}>
                                            {report.user_name}
                                        </div>
                                        <div style={cstyle(3, 1, 3, 7)}>
                                            <b>Form Created: </b>
                                        </div>
                                        <div style={cstyle(3, 7, 3, 13, true)}>
                                            {report.timestamp}
                                        </div>
                                        <div style={cstyle(4, 1, 4, 7)}>
                                            <b>Personnel </b>
                                        </div>
                                        <div style={cstyle(4, 7, 4, 13, true)}>
                                            {report.personnel_name}
                                        </div>
                                        <div style={cstyle(5, 1, 5, 7)}>
                                            <b>Longitude: </b>
                                        </div>
                                        <div style={cstyle(5, 7, 5, 13, true)}>
                                            {report.location_lon}
                                        </div>
                                        <div style={cstyle(6, 1, 6, 7)}>
                                            <b>Latitude: </b>
                                        </div>
                                        <div style={cstyle(6, 7, 6, 13, true)}>
                                            {report.location_lat}
                                        </div>
                                        <div style={cstyle(7, 1, 7, 7)}>
                                            <b>Email</b>
                                        </div>
                                        <div style={cstyle(7, 7, 7, 13)}>
                                            {report.user_email}
                                        </div>
                                    </div>
                                </div>
                                <div
                                    style={{
                                        width: "30%",
                                        float: "left",
                                        marginLeft: "2%",
                                    }}
                                >
                                    <MapContainer
                                        lat={+report.location_lat}
                                        long={+report.location_lon}
                                        style={{ width: "80%" }}
                                    />
                                </div>
                            </div>
                            <div style={{ width: "100%", clear: "both" }}>
                                <div className="break" style={gstyle(21, 8)}>
                                    <div
                                        style={cstyle(1, 1, 1, 1, false, true)}
                                    >
                                        <span
                                            style={{
                                                position: "relative",
                                                margin: "0 auto",
                                                display: "block",
                                                textAlign: "center",
                                            }}
                                        >
                                            <b>Image</b>
                                        </span>
                                    </div>
                                    <div
                                        style={cstyle(1, 2, 1, 2, false, true)}
                                    >
                                        <span
                                            style={{
                                                position: "relative",
                                                margin: "0 auto",
                                                display: "block",
                                                textAlign: "center",
                                            }}
                                        >
                                            <b>Name</b>
                                        </span>
                                    </div>
                                    <div
                                        style={cstyle(1, 3, 1, 3, false, true)}
                                    >
                                        <span
                                            style={{
                                                position: "relative",
                                                margin: "0 auto",
                                                display: "block",
                                                textAlign: "center",
                                            }}
                                        >
                                            <b>Yes/No</b>
                                        </span>
                                    </div>

                                    <div
                                        style={cstyle(1, 4, 1, 8, false, true)}
                                    >
                                        <b>Comments:</b>
                                    </div>
                                    <div style={cstyle(2, 1, 2, 1, true)}>
                                        <span
                                            style={{
                                                position: "relative",
                                                margin: "0 auto",
                                                display: "block",
                                                textAlign: "center",
                                            }}
                                        >
                                            <img
                                                height={iconH}
                                                width={iconW}
                                                src="https://firebasestorage.googleapis.com/v0/b/vrcore-6845f.appspot.com/o/images%2FPPE_icons%2F53519395-1cf37480-3acb-11e9-9dd6-7696a8f2b433.png?alt=media&token=e7159d37-a967-4edb-963c-c73416363f7a"
                                                alt={"Googles"}
                                            />
                                        </span>
                                    </div>
                                    <div style={cstyle(2, 2, 2, 2, true)}>
                                        <span
                                            style={{
                                                position: "relative",
                                                margin: "0 auto",
                                                display: "block",
                                                textAlign: "center",
                                            }}
                                        >
                                            <b>Goggles Used:</b>
                                        </span>
                                    </div>
                                    <div style={cstyle(2, 3, 2, 3, true)}>
                                        {iconCheck(report.inps_1_status)}
                                    </div>
                                    <div style={cstyle(2, 4, 2, 8, true)}>
                                        {report.inps_1_comments}
                                    </div>
                                    <div style={cstyle(3, 1, 3, 1, true)}>
                                        <span
                                            style={{
                                                position: "relative",
                                                margin: "0 auto",
                                                display: "block",
                                                textAlign: "center",
                                            }}
                                        >
                                            <img
                                                height={iconH}
                                                width={iconW}
                                                src="https://firebasestorage.googleapis.com/v0/b/vrcore-6845f.appspot.com/o/images%2FPPE_icons%2F53519403-1d8c0b00-3acb-11e9-9d04-09982619805a.png?alt=media&token=984d7285-ce77-4ea6-8d75-5eaf4a065bdd"
                                                alt={"wellington"}
                                            />
                                        </span>
                                    </div>
                                    <div style={cstyle(3, 2, 3, 3, true)}>
                                        <span
                                            style={{
                                                position: "relative",
                                                margin: "0 auto",
                                                display: "block",
                                                textAlign: "center",
                                            }}
                                        >
                                            <b>Wellingtons Used:</b>
                                        </span>
                                    </div>
                                    <div style={cstyle(3, 3, 3, 3, true)}>
                                        {iconCheck(report.inps_2_status)}
                                    </div>
                                    <div style={cstyle(3, 4, 3, 8, true)}>
                                        {report.inps_2_comments}
                                    </div>

                                    <div style={cstyle(4, 1, 4, 1, true)}>
                                        <span
                                            style={{
                                                position: "relative",
                                                margin: "0 auto",
                                                display: "block",
                                                textAlign: "center",
                                            }}
                                        >
                                            <img
                                                height={iconH}
                                                width={iconW}
                                                src="https://firebasestorage.googleapis.com/v0/b/vrcore-6845f.appspot.com/o/images%2FPPE_icons%2F53519401-1d8c0b00-3acb-11e9-8147-a2129c8e854c.png?alt=media&token=53c87e9a-3a50-438b-aa5d-448998f37b62"
                                                alt={"Ear Protection"}
                                            />
                                        </span>
                                    </div>
                                    <div style={cstyle(4, 2, 4, 3, true)}>
                                        <span
                                            style={{
                                                position: "relative",
                                                margin: "0 auto",
                                                display: "block",
                                                textAlign: "center",
                                            }}
                                        >
                                            <b>T-Shirt Used:</b>
                                        </span>
                                    </div>
                                    <div style={cstyle(4, 3, 4, 3, true)}>
                                        {iconCheck(report.inps_3_status)}
                                    </div>
                                    <div style={cstyle(4, 4, 4, 8, true)}>
                                        {report.inps_3_comments}
                                    </div>
                                    <div style={cstyle(5, 1, 5, 1, true)}>
                                        <span
                                            style={{
                                                position: "relative",
                                                margin: "0 auto",
                                                display: "block",
                                                textAlign: "center",
                                            }}
                                        >
                                            <img
                                                height={iconH}
                                                width={iconW}
                                                src="https://firebasestorage.googleapis.com/v0/b/vrcore-6845f.appspot.com/o/images%2FPPE_icons%2F53519392-1c5ade00-3acb-11e9-96e2-f23a903990c6.png?alt=media&token=3e0b7d1b-473c-48b8-a8e4-a97d58f6317b"
                                                alt={"Fleece"}
                                            />
                                        </span>
                                    </div>
                                    <div style={cstyle(5, 2, 5, 2, true)}>
                                        <span
                                            style={{
                                                position: "relative",
                                                margin: "0 auto",
                                                display: "block",
                                                textAlign: "center",
                                            }}
                                        >
                                            <b>Fleece Used:</b>
                                        </span>
                                    </div>
                                    <div style={cstyle(5, 3, 5, 3, true)}>
                                        {iconCheck(report.inps_4_status)}
                                    </div>
                                    <div style={cstyle(5, 4, 5, 8, true)}>
                                        {report.inps_4_comments}
                                    </div>
                                    <div style={cstyle(6, 1, 6, 1, true)}>
                                        <span
                                            style={{
                                                position: "relative",
                                                margin: "0 auto",
                                                display: "block",
                                                textAlign: "center",
                                            }}
                                        >
                                            <img
                                                height={iconH}
                                                width={iconW}
                                                src="https://firebasestorage.googleapis.com/v0/b/vrcore-6845f.appspot.com/o/images%2FPPE_icons%2F53519399-1cf37480-3acb-11e9-96a6-debb5663acd2.png?alt=media&token=14b4167b-b04d-4218-bc3c-dc0f308e8f41"
                                                alt={"Steel Toe"}
                                            />
                                        </span>
                                    </div>
                                    <div style={cstyle(6, 2, 6, 2, true)}>
                                        <span
                                            style={{
                                                position: "relative",
                                                margin: "0 auto",
                                                display: "block",
                                                textAlign: "center",
                                            }}
                                        >
                                            <b>Steel Toe Used:</b>
                                        </span>
                                    </div>
                                    <div style={cstyle(6, 3, 6, 3, true)}>
                                        {iconCheck(report.inps_5_status)}
                                    </div>
                                    <div style={cstyle(6, 4, 6, 8, true)}>
                                        {report.inps_5_comments}
                                    </div>
                                    <div style={cstyle(7, 1, 7, 2, true)}>
                                        <span
                                            style={{
                                                position: "relative",
                                                margin: "0 auto",
                                                display: "block",
                                                textAlign: "center",
                                            }}
                                        >
                                            <img
                                                height={iconH}
                                                width={iconW}
                                                src="https://firebasestorage.googleapis.com/v0/b/vrcore-6845f.appspot.com/o/images%2FPPE_icons%2F53519405-1d8c0b00-3acb-11e9-8841-b13bd56dfec7.png?alt=media&token=ba4ad920-62f1-482f-bca8-b6385d5f3ec8"
                                                alt={"Winter Jacket"}
                                            />
                                        </span>
                                    </div>
                                    <div style={cstyle(7, 2, 7, 2, true)}>
                                        <span
                                            style={{
                                                position: "relative",
                                                margin: "0 auto",
                                                display: "block",
                                                textAlign: "center",
                                            }}
                                        >
                                            <b>Winter Jacket Used:</b>
                                        </span>
                                    </div>
                                    <div style={cstyle(7, 3, 7, 3, true)}>
                                        {iconCheck(report.inps_6_status)}
                                    </div>
                                    <div style={cstyle(7, 4, 7, 8, true)}>
                                        {report.inps_6_comments}
                                    </div>
                                    <div style={cstyle(8, 1, 8, 2, true)}>
                                        <span
                                            style={{
                                                position: "relative",
                                                margin: "0 auto",
                                                display: "block",
                                                textAlign: "center",
                                            }}
                                        >
                                            <img
                                                height={iconH}
                                                width={iconW}
                                                src="https://firebasestorage.googleapis.com/v0/b/vrcore-6845f.appspot.com/o/images%2FPPE_icons%2F53519400-1cf37480-3acb-11e9-8c84-be440609c4c1.png?alt=media&token=54b740e7-d668-4095-a80e-c192e0bc0f72"
                                                alt={"Summer Jacket"}
                                            />
                                        </span>
                                    </div>
                                    <div style={cstyle(8, 2, 8, 2, true)}>
                                        <span
                                            style={{
                                                position: "relative",
                                                margin: "0 auto",
                                                display: "block",
                                                textAlign: "center",
                                            }}
                                        >
                                            <b>Summer Jacket Used:</b>
                                        </span>
                                    </div>
                                    <div style={cstyle(8, 3, 8, 3, true)}>
                                        {iconCheck(report.inps_7_status)}
                                    </div>
                                    <div style={cstyle(8, 4, 8, 8, true)}>
                                        {report.inps_7_comments}
                                    </div>
                                    <div style={cstyle(9, 1, 9, 2, true)}>
                                        <span
                                            style={{
                                                position: "relative",
                                                margin: "0 auto",
                                                display: "block",
                                                textAlign: "center",
                                            }}
                                        >
                                            <img
                                                height={iconH}
                                                width={iconW}
                                                src="https://firebasestorage.googleapis.com/v0/b/vrcore-6845f.appspot.com/o/images%2FPPE_icons%2F53519396-1cf37480-3acb-11e9-8aed-e31fdf80c0ea.png?alt=media&token=339c4e95-88c4-4b4a-80f7-ecb9867c5f84"
                                                alt={"Hard Hat"}
                                            />
                                        </span>
                                    </div>
                                    <div style={cstyle(9, 2, 9, 2, true)}>
                                        <span
                                            style={{
                                                position: "relative",
                                                margin: "0 auto",
                                                display: "block",
                                                textAlign: "center",
                                            }}
                                        >
                                            <b>Hard Hat Used:</b>
                                        </span>
                                    </div>
                                    <div style={cstyle(9, 3, 9, 3, true)}>
                                        {iconCheck(report.inps_8_status)}
                                    </div>
                                    <div style={cstyle(9, 4, 9, 8, true)}>
                                        {report.inps_8_comments}
                                    </div>
                                    <div style={cstyle(10, 1, 10, 2, true)}>
                                        <span
                                            style={{
                                                position: "relative",
                                                margin: "0 auto",
                                                display: "block",
                                                textAlign: "center",
                                            }}
                                        >
                                            <img
                                                height={iconH}
                                                width={iconW}
                                                src="https://firebasestorage.googleapis.com/v0/b/vrcore-6845f.appspot.com/o/images%2FPPE_icons%2F53519402-1d8c0b00-3acb-11e9-8ae8-6db6b9c0ac5e.png?alt=media&token=d9be55b0-3dd9-4398-9b74-95b8e3136ff8"
                                                alt={"Trousers"}
                                            />
                                        </span>
                                    </div>
                                    <div style={cstyle(10, 2, 10, 2, true)}>
                                        <span
                                            style={{
                                                position: "relative",
                                                margin: "0 auto",
                                                display: "block",
                                                textAlign: "center",
                                            }}
                                        >
                                            <b>Trousers Used:</b>
                                        </span>
                                    </div>
                                    <div style={cstyle(10, 3, 10, 3, true)}>
                                        {iconCheck(report.inps_9_status)}
                                    </div>
                                    <div style={cstyle(10, 4, 10, 8, true)}>
                                        {report.inps_9_comments}
                                    </div>
                                    <div style={cstyle(11, 1, 11, 2, true)}>
                                        <span
                                            style={{
                                                position: "relative",
                                                margin: "0 auto",
                                                display: "block",
                                                textAlign: "center",
                                            }}
                                        >
                                            <img
                                                height={iconH}
                                                width={iconW}
                                                src="https://firebasestorage.googleapis.com/v0/b/vrcore-6845f.appspot.com/o/images%2FPPE_icons%2F53519394-1c5ade00-3acb-11e9-9ff6-f86a370969d0.png?alt=media&token=1320d3f8-3afc-497c-b19d-25d1d519ed6e"
                                                alt={"Gas Monitor"}
                                            />
                                        </span>
                                    </div>
                                    <div style={cstyle(11, 2, 11, 2, true)}>
                                        <span
                                            style={{
                                                position: "relative",
                                                margin: "0 auto",
                                                display: "block",
                                                textAlign: "center",
                                            }}
                                        >
                                            <b>Gas Monitor Used:</b>
                                        </span>
                                    </div>
                                    <div style={cstyle(11, 3, 11, 3, true)}>
                                        {iconCheck(report.inps_10_status)}
                                    </div>
                                    <div style={cstyle(11, 4, 11, 8, true)}>
                                        {report.inps_10_comments}
                                    </div>
                                    <div style={cstyle(12, 1, 12, 2, true)}>
                                        <span
                                            style={{
                                                position: "relative",
                                                margin: "0 auto",
                                                display: "block",
                                                textAlign: "center",
                                            }}
                                        >
                                            <img
                                                height={iconH}
                                                width={iconW}
                                                src="https://firebasestorage.googleapis.com/v0/b/vrcore-6845f.appspot.com/o/images%2FPPE_icons%2F53519404-1d8c0b00-3acb-11e9-8506-25b623067958.png?alt=media&token=ad4c7e30-8ca9-4d98-be82-8329ab62c7e8"
                                                alt={"Wet Wear"}
                                            />
                                        </span>
                                    </div>
                                    <div style={cstyle(12, 2, 12, 2, true)}>
                                        <span
                                            style={{
                                                position: "relative",
                                                margin: "0 auto",
                                                display: "block",
                                                textAlign: "center",
                                            }}
                                        >
                                            <b>Wet Wear Used:</b>
                                        </span>
                                    </div>
                                    <div style={cstyle(12, 3, 12, 3, true)}>
                                        {iconCheck(report.inps_11_status)}
                                    </div>
                                    <div style={cstyle(12, 4, 12, 8, true)}>
                                        {report.inps_11_comments}
                                    </div>
                                    <div style={cstyle(13, 1, 13, 1, true)}>
                                        <span
                                            style={{
                                                position: "relative",
                                                margin: "0 auto",
                                                display: "block",
                                                textAlign: "center",
                                            }}
                                        >
                                            <img
                                                height={iconH}
                                                width={iconW}
                                                src="https://firebasestorage.googleapis.com/v0/b/vrcore-6845f.appspot.com/o/images%2FPPE_icons%2F53519398-1cf37480-3acb-11e9-9980-3aebbc5f8dbd.png?alt=media&token=0eeaab07-1f54-4f75-a8b2-5e15988ceae6"
                                                alt={"Lanyard"}
                                            />
                                        </span>
                                    </div>
                                    <div style={cstyle(13, 2, 13, 2, true)}>
                                        <span
                                            style={{
                                                position: "relative",
                                                margin: "0 auto",
                                                display: "block",
                                                textAlign: "center",
                                            }}
                                        >
                                            <b>Lanyard Used:</b>
                                        </span>
                                    </div>
                                    <div style={cstyle(13, 3, 13, 3, true)}>
                                        {iconCheck(report.inps_12_status)}
                                    </div>
                                    <div style={cstyle(13, 4, 13, 8, true)}>
                                        {report.inps_12_comments}
                                    </div>
                                    <div style={cstyle(14, 1, 14, 1, true)}>
                                        <span
                                            style={{
                                                position: "relative",
                                                margin: "0 auto",
                                                display: "block",
                                                textAlign: "center",
                                            }}
                                        >
                                            {" "}
                                            <img
                                                height={iconH}
                                                width={iconW}
                                                src="https://firebasestorage.googleapis.com/v0/b/vrcore-6845f.appspot.com/o/images%2FPPE_icons%2F53519397-1cf37480-3acb-11e9-8b85-07601fb66d38.png?alt=media&token=2a40425b-f21f-46dd-a25d-d9c3e6038ee4"
                                                alt={"Harness"}
                                            />
                                        </span>
                                    </div>
                                    <div style={cstyle(14, 2, 14, 2, true)}>
                                        <span
                                            style={{
                                                position: "relative",
                                                margin: "0 auto",
                                                display: "block",
                                                textAlign: "center",
                                            }}
                                        >
                                            {" "}
                                            <b>Harness Used:</b>
                                        </span>
                                    </div>
                                    <div style={cstyle(14, 3, 14, 3, true)}>
                                        {iconCheck(report.inps_13_status)}
                                    </div>
                                    <div style={cstyle(14, 4, 14, 8, true)}>
                                        {report.inps_13_comments}
                                    </div>
                                    <div style={cstyle(15, 1, 15, 1, true)}>
                                        <span
                                            style={{
                                                position: "relative",
                                                margin: "0 auto",
                                                display: "block",
                                                textAlign: "center",
                                            }}
                                        >
                                            {" "}
                                            <img
                                                height={iconH}
                                                width={iconW}
                                                src="https://firebasestorage.googleapis.com/v0/b/vrcore-6845f.appspot.com/o/images%2FPPE_icons%2F53519651-a4d97e80-3acb-11e9-9157-e932d164703f.png?alt=media&token=2b314d5b-00ea-41dc-a8dd-f01279b0b16b"
                                                alt={"Ear Protection"}
                                            />
                                        </span>
                                    </div>
                                    <div style={cstyle(15, 2, 15, 2, true)}>
                                        <span
                                            style={{
                                                position: "relative",
                                                margin: "0 auto",
                                                display: "block",
                                                textAlign: "center",
                                            }}
                                        >
                                            {" "}
                                            <b>Ear Protection Used: </b>
                                        </span>
                                    </div>
                                    <div style={cstyle(15, 3, 15, 3, true)}>
                                        {iconCheck(report.inps_14_status)}
                                    </div>
                                    <div style={cstyle(15, 4, 15, 8, true)}>
                                        {report.inps_14_comments}
                                    </div>
                                </div>
                            </div>
                            <div style={gstyle(4, 9, null, color)}>
                                <div style={cstyle(1, 1, 1, 1, false, true)}>
                                    <b>Attached Signatures</b>
                                </div>
                                {report.attached_signatures &&
                                    this.renderSigs(report.attached_signatures)}
                            </div>
                        </div>
                    )}
                </CardContent>
            </Card>
        );
    }
}

export default connect(
    (store) => {
        return {
            report: selectCurrentReport(store),
        };
    },
    { getReport, getStandaloneReport }
)(PPEInspection);
